export const POSITION_CONFIGS = {
  'Full Stack Engineer': {
    questions: {
        techQuestion: 'Are you an expert with Node.js, Python, React, Tailwind, and TypeScript? Please describe your experience with each technology ',
        aiQuestion: 'Do you have experience creating AI features? ',
        microservicesQuestion: 'Please describe your experience with microservices architecture and system design ',
        teamLeadershipQuestion: 'Describe your experience in managing and building development teams ',
        agileQuestion: 'What is your experience with Agile methodologies and sprint planning? ',
        linkType: 'Portfolio/GitHub'
      },
      additionalFields: [
        'microservices',
        'teamLeadership',
        'agile'
      ]
  },
  'Frontend Engineer': {
    questions: {
      techQuestion: 'Are you an expert with React, Tailwind, and TypeScript? Please describe your experience *',
      aiQuestion: 'Do you have experience creating AI features? *',
      linkType: 'Portfolio'
    },
    additionalFields: []
  },
  'Backend Engineer': {
    questions: {
      techQuestion: 'Are you an expert with node js and python?',
      aiQuestion: 'Do you have experience creating AI features?',
      dbQuestion: 'What databases have you worked with?',
      microservicesQuestion: 'Describe your experience with microservices',
      linkType: 'GitHub'
    },
    additionalFields: []
  },
  'UX UI Designer': {
    questions: {
      techQuestion: 'What design tools are you proficient with? (Figma, Adobe XD, etc.)',
      aiQuestion: 'Do you have experience with AI-powered design tools?',
      linkType: 'Portfolio'
    },
    additionalFields: []
  },
  'Product Owner': {
    questions: {
      techQuestion: 'Please describe a complex product you\'ve managed from concept to launch. What were the main challenges, and how did you address them?',
      ecommerceQuestion: 'What specific experience do you have in e-commerce or SaaS environments?',
      methodologiesQuestion: 'Which project management methodologies (e.g., Scrum, Kanban) and tools (e.g., Jira, Trello) are you most proficient in, and how have you used them effectively?',
      communicationQuestion: 'How do you handle communication and alignment among diverse teams and stakeholders during product development?',
      linkType: 'Portfolio'
    },
    additionalFields: [
      'methodologies',
      'communication',
      'ecommerce'
    ]
  },
  'Technical Project Manager': {
    questions: {
      techQuestion: 'Please describe a complex technical project you\'ve managed from start to finish. What were the main challenges, and how did you address them?',
      ecommerceQuestion: 'What specific experience do you have in e-commerce or SaaS environments?',
      methodologiesQuestion: 'Which project management methodologies (e.g., Scrum, Kanban) and tools (e.g., Jira, Trello) are you most proficient in, and how have you used them effectively?',
      communicationQuestion: 'How do you handle communication and alignment among diverse teams and stakeholders during a project?',
      linkType: 'Portfolio'
    },
    additionalFields: [
      'methodologies',
      'communication',
      'ecommerce'
    ]
  }
};

// Add a helper function to normalize position titles
export const normalizePositionTitle = (title) => {
  const normalizedTitle = title
    .replace(/fullstack/i, 'Full Stack')
    .replace(/\s+software\s+/i, ' ')
    .trim();
  
  return normalizedTitle;
}; 